<template>
  <vs-table v-if="show" ref="table" :params="params" :options="options"></vs-table>
</template>

<script>
  import VsTable from "../_framework/VsTable.vue";
  import Constants from "../Constants.js";
  import SelectIntermediateProducts from "../components/SelectIntermediateProducts.vue";
  import SetProductDetails from "../components/SetProductDetails.vue";
  import {mapState, mapMutations, mapActions} from "vuex";
  import EventBus from "../bus.js";
  import ClientSelect from "../components/ClientSelect.vue";
  import VsSelect from '../_framework/VsSelect.vue';
  import BaseService from "../_framework/api/BaseService";
  import PsSwitch from "../components/PsSwitch.vue";
  import CustomEntity from "../components/CustomEntity";

  export default {
    name: "Products",
    components: {
      VsTable,
      SelectIntermediateProducts,
      SetProductDetails,
      ClientSelect,
      VsSelect,
      PsSwitch,
      CustomEntity
    },
    props: [
      "isSelectMode"
    ],
    data() {
      return {
        unitItems: [],
        access: {},
        show: true,
        params: {
          entity: "products",
          list: [],
          headers: {
            productCode: {
              title: "کد محصول",
              type: "number",
              isSearchable: true,
              rowAlignment: "center",
              show: false,
              visibility: false
            },
            productName: {
              title: "نام محصول",
              type: "text",
              isSearchable: true,
              rowAlignment: "center"
            },
            unit: {
              title: "واحد",
              type: "custom",
              isSearchable: false,
              component: VsSelect,
              multiple: false,
              label: "unitValue",
              rowAlignment: "center",
              inHeader: true,
              listParams: {}
            },
            details: {
              title: "جزییات محصول",
              type: "custom",
              inHeader: true,
              component: SetProductDetails,
              rowAlignment: "center",
            },
            materials: {
              title: "محصولات میانی",
              type: "custom",
              component: SelectIntermediateProducts,
              rowAlignment: "center",
              // multiple: true,
              // label: "productName",
              inHeader: true
              // listParams: {
              //   requestURI: "products"
              // }
            },
            sellable: {
              title: "قابلیت فروش",
              type: "custom",
              component: PsSwitch,
              inHeader: true,
              rowAlignment: 'center'
            },
            stock: {
              title: "موجودی",
              type: "custom",
              component: CustomEntity,
              inHeader: true,
              rowAlignment: "center",

            },
            // stockQuantity: {
            //   title: "موجودی",
            //   type: "number",
            //   inHeader: false,
            //   rowAlignment: "center"
            // },

            stockMasahat: {
              title: "متر مربع",
              type: "number",
              inHeader: false,
              rowAlignment: "center"
            },
            stockHajm: {
              title: "متر مکعب",
              type: "number",
              inHeader: false,
              rowAlignment: "center"
            },
            stockVazn: {
              title: "وزن (کیلوگرم)",
              type: "number",
              inHeader: false,
              rowAlignment: "center"
            },


            title3: {
              title: "عنوان 3",
              type: "text",
              isSearchable: false,
              inHeader: false,
              rowAlignment: "center"
            },
          }
        },
        options: {
          isSelectMode: this.isSelectMode,
          hasActions: true,
          hasActionsInHeader: true,
          clickableRows: true,

          beforeCreateEntity: input => {
            if (input && input["materials"]) {
              input["materials"] = input["materials"].map(p => {
                return {
                  material: p.material.id,
                  percentage: p.percentage
                };
              });
            }
            // if (input && input["details"]) {
            //   console.log(input["details"])
            //   input["details"] = input["details"].map(d => {
            //   console.log(d)
            //     return {
            //       customerName: d.customerName,
            //       ertefa: d.ertefa,
            //       ghotr: d.ghotr,
            //       isoCode: d.isoCode,
            //       standardName: d.standardName,
            //       standardName2: d.standardName2,
            //       tool: d.tool,
            //       weight: d.weight,
            //
            //     };
            //   });
            // }
            if (input && input["unit"]) {
              input["unit"] = input["unit"].id || input["unit"];
            }
            this.refreshTable();
            return input;
          },
          beforeUpdateEntity: input => {
            if (input && input["materials"]) {
            }
            if (input && input["unit"]) {
              input["unit"] = input["unit"].id || input["unit"];
              this.refreshTable();
            }
            this.refreshTable();
            return input;
          },
          beforeFetchEntityList: input => {
            return input;
          },
          onRowClicked: row => {
            this.$emit("onRowSelect", row);
          },
          onRowDoubleClicked: row => {
            this.$emit("onRowDoubleClicked", row);
          },
          // onCreateHeaderActionClicked: () => {
          //   console.log("open modal");
          // },
          getTopRightButtons: () => {
            let arr = [];
            let searchToggleButton = {
              component: "search-toggle-button"
            };
            arr.push(searchToggleButton);
            return arr;
          },
          getTopLeftButtons: () => {
            let arr = [];
            let self = this;
            // console.log(self.options.hasActions);
            let addItemButton = {
              component: "toggle-table-actions-button",
              params: {

                onClick() {
                  self.options.hasActions = !self.options.hasActions;
                }
              }
            };
            let stackFilterButton = {
              component: "stock-filter-button"
            };
            let sellableButton = {
              component: "sellable-button"
            };
            let rawMaterialButton = {
              component: "raw-material-filter-button"
            };
            arr.push(sellableButton);
            arr.push(stackFilterButton);
            arr.push(rawMaterialButton);
            arr.push(addItemButton);
            return arr;
          }
        }
      };
    },
    beforeMount() {
      if (this.$route && this.$route.path) {
        this.options.access = checkAccess(this.$route.path);
      } else {
        this.options.access = checkAccess("products");
      }
      if (this.isSelectMode === true) {
        this.options.hasActions = false;
        delete this.params.headers.details;
        delete this.params.headers.stockMasahat;
        delete this.params.headers.stockHajm;
        delete this.params.headers.stockVazn;
        delete this.params.headers.sellable;

        const title2 = {
          title: "عنوان 2",
          type: "text",
          isSearchable: false,
          inHeader: false,
          rowAlignment: "center"
        };
        const title1 = {
          title: "عنوان 1",
          type: "text",
          isSearchable: false,
          inHeader: false,
          rowAlignment: "center"
        };
        this.params.headers.title1 = title1;
        this.params.headers.title2 = title2;
      }
      // if (this.$route.query.selectMode !== undefined && this.$route.query.selectMode === true) {
      //   this.props.options.hasActions = false;
      //   this.props.options.hasActionsInHeader = false;
      // }
      // this.show = !!this.options.access;
      // console.log(this.show);
      this.getUnits();
    },
    mounted() {
      // if (this.$route && this.$route.path) {
      //   this.options.access = checkAccess(this.$route.path);
      //   console.log(this.$route.path);
      //   console.log(this.$route);
      // } else {
      //   this.options.access = checkAccess("products");
      //   console.log("fff");
      // }
      // this.show = !!this.options.access;
      // console.log(this.show);
      // this.getUnits();

      EventBus.$on("materialChanged", () => {
        this.refreshTable();
      });
    },
    computed: {
      ...mapState(["vsTableFeed"])
    },
    methods: {
      getUnits() {
        new BaseService('units', '/GetAll').getList().then((response) => {

          this.params.headers.unit.listParams.selectItems = response.data;
        }).catch((error) => {
          console.log(error)
        });
      },
      refreshTable() {
        /*this.show = false;
        setTimeout(() => {
            this.show = true;
        }, 200);*/
        this.$refs.table.onFetchEntityList();
        // this.getUnits();
        // this.$refs.table.onFetchEntityList({pageIndex: this.$refs.table.list.pageIndex});
      }
    },
    watch: {}
  };
</script>
